import ecomBg from 'assets/img/illustrations/ecommerce-bg.png';
import Background from 'components/common/Background';
import Flex from 'components/common/Flex';
import PropTypes from 'prop-types';
import React from 'react';
import { Card } from 'react-bootstrap';
import Notification from './Notification';

const GreetingCard = () => {
   const notifications = [
    {
      id: 1,
      title: '<strong>5 products</strong> didn’t publish to your Facebook page',
      linkFor: 'products',
      type: 'warning'
    },
    {
      id: 2,
      title: '<strong>7 orders</strong> have payments that need to be captured',
      linkFor: 'payments'
    },
    {
      id: 3,
      title: '<strong>50+ orders</strong> need to be fulfilled',
      linkFor: 'orders'
    }
  ];
  const currentDate = new Date();
  const currentHour = currentDate.getHours();
  
  let greeting = '';
  if (currentHour >= 5 && currentHour < 12) {
    greeting = 'Good Morning';
  } else if (currentHour >= 12 && currentHour < 18) {
    greeting = 'Good Afternoon';
  } else {
    greeting = 'Good Evening';
  }
  
  const userData = JSON.parse(localStorage.getItem('userData'));
  return (
    <Card className="bg-transparent-50 overflow-hidden">
      <Card.Header className="position-relative">
        <Background
         // image={ecomBg}
          className="d-none d-md-block bg-card z-index-1"
          style={{
            backgroundSize: '230px',
            backgroundPosition: 'right bottom',
            zIndex: '-1'
          }}
        />
        <div className="position-relative z-index-2">
          <div>
            <h3 className="text-primary mb-1">{greeting}, {userData && userData.contactPerson}</h3>
            <h5 className="text-700">
            Here’s what's happening with your support ticket today
            </h5>
          </div>
          {/* <Flex className="py-3">
            <div className="pe-3">
              <p className="text-600 fs--1 fw-medium">Today's visit</p>
              <h4 className="text-800 mb-0">14,209</h4>
            </div>
            <div className="ps-3">
              <p className="text-600 fs--1">Today’s total sales</p>
              <h4 className="text-800 mb-0">$21,349.29</h4>
            </div>
          </Flex>
           */}
        </div>
      </Card.Header>
    </Card>
  );
};

GreetingCard.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.object)
};

export default GreetingCard;
